import LocalSettingsProto from "../../../../core/gd/settings/local-settings/local-settings-v4"

export default class NavigationMenu_HomeLocalSettings extends LocalSettingsProto {

    private _expandedViews: ID[] = []

    constructor() {
        super('menu-home-'+gd.companyId)

        const values = this._readFromLocalStorage()

        this._expandedViews = _.get(values, 'expandedViews', [])
    }

    get expandedViews() {
        return this._expandedViews
    }

    set expandedViews(value:ID[]) {
        this._expandedViews = value
        this.save()
    }

    toObject() {
        return {
            expandedViews: this._expandedViews,
        }
    }
}
